<template>
    <div>
        <slot />
      </div>
  </template>
  
  <script>
  
  export default {
    name: 'blank',
    created() {
      this.scrollToTop();
    },
    methods: {
      scrollToTop() {
        window.scrollTo(0, 0);
      }
    },
  }
  </script>
  
  <style lang="scss" scoped></style>